/**
 * Utils for language mapping and normalization between UI and API
 */

export const LANGUAGE_MAP: Record<string, string> = {
    'TypeScript': 'typescript',
    'JavaScript': 'javascript',
    'Python': 'python',
    'C#': 'csharp',
    'Java': 'java',
    'Go': 'go',
    'Rust': 'rust',
    'Ruby': 'ruby',
    'PHP': 'php',
};

/**
 * Normalizes a display language name (e.g. "C#") to an API-compatible ID (e.g. "csharp")
 */
export function normalizeLanguage(lang: string): string {
    return LANGUAGE_MAP[lang] || lang.toLowerCase();
}

/**
 * Detects language from filename extension
 */
export function detectLanguageFromExtension(fileName: string): string {
    const ext = fileName.split('.').pop()?.toLowerCase();
    const extensionMap: Record<string, string> = {
        'ts': 'typescript',
        'tsx': 'typescript',
        'js': 'javascript',
        'jsx': 'javascript',
        'py': 'python',
        'cs': 'csharp',
        'java': 'java',
        'go': 'go',
        'rs': 'rust',
        'rb': 'ruby',
        'php': 'php'
    };
    
    return extensionMap[ext || ''] || 'javascript';
}
